export default __webpack_public_path__ + "static/media/pulledStock.1f6f5680.svg";